export default __webpack_public_path__ + "static/media/background_bottom.6ad4e379.svg";